import ToggleItem from "./ToggleItem";
import AudioManager from "../Shared/AudioManager";

const {ccclass, property} = cc._decorator;

@ccclass
export default class CommonToggleContainer extends cc.Component {
    @property(cc.Prefab)
    pfbToggle: cc.Prefab = null

    @property(cc.Boolean)
    isSelectFirstItem: boolean = true

    @property(cc.Boolean)
    isAllowedMultipleSelect: boolean = false

    @property([cc.Component.EventHandler])
    toggleEvents: cc.Component.EventHandler[] = [];

    private _checkedToggle: ToggleItem = null

    @property({type: ToggleItem, visible: false})
    get checkedToggle () {
        return this._checkedToggle
    }

    onLoad () {
        // 针对编辑器里面添加的Toggle
        for (let i = 0; i < this.node.children.length; i++) {
            let toggle = this.node.children[i].getComponent(ToggleItem)
            if (toggle) {
                this.addClickToggleEvent(toggle)
            }
        }
        
        this.node.on(cc.Node.EventType.CHILD_REMOVED, this.onRemovedChild, this)
    }

    start () {
        if (!this._checkedToggle && this.isSelectFirstItem) {
            this.selectFirstItem()
        }
    }

    onDestroy () {
        this.node.off(cc.Node.EventType.CHILD_REMOVED, this.onRemovedChild, this)
    }

    clear () {
        this.node.children.forEach(child => {
            child.destroy()
        });

        this._checkedToggle = null
    }

    onRemovedChild (child) {
        let toggle = child.getComponent(ToggleItem)
        if (toggle && this._checkedToggle === toggle) {
            this._checkedToggle = null
        }
    }

    onToggleClick (event) {
        AudioManager.playSound("toggle")
        this.selectToggle(event.target.getComponent(ToggleItem))
    }

    selectToggle(toggle) {
        if (!this.isAllowedMultipleSelect && this._checkedToggle && this._checkedToggle === toggle || !this.enabled) {
            return
        }

        if (this._checkedToggle) {
            this._checkedToggle.isChecked = false
        }

        this._checkedToggle = toggle
        this._checkedToggle.isChecked = true
        this.emitMsg()
    }

    selectFirstItem () {
        for (let i = 0; i < this.node.children.length; i++) {
            let toggle = this.node.children[i].getComponent(ToggleItem)
            if (toggle) {
                this.selectToggle(toggle)
                break
            }
        }
    }

    private emitMsg () {
        this.toggleEvents.forEach(eventHandler => {
            eventHandler.emit([this._checkedToggle])
        });
    }

    private addClickToggleEvent (toggle: ToggleItem) {
        let button = toggle.addComponent(cc.Button)
        let clickEventHandler = new cc.Component.EventHandler()
        
        clickEventHandler.target = this.node
        clickEventHandler.component = "CommonToggleContainer"
        clickEventHandler.handler = "onToggleClick"
        button.clickEvents.push(clickEventHandler)
    }

    addDefaultToggle (name: string, userData?: any, width?: number) {
        if (!this.pfbToggle) {
            cc.log("pfbToggle未设置")
            return
        }

        let toggle = cc.instantiate(this.pfbToggle).getComponent(ToggleItem)
        toggle.toggleName = name
        toggle.userData = userData || ""
        width && (toggle.node.width = width)
        this.addToggle(toggle)

        return toggle
    }

    addToggle (toggle: ToggleItem) {
        toggle.isChecked = false
        toggle.node.parent = this.node
        this.addClickToggleEvent(toggle)

        if (!CC_EDITOR && !this._checkedToggle && this.isSelectFirstItem) {
            this.selectToggle(toggle)
        }
    }
}
